import { useState } from "react";
import { Volume2, MapPin, ChevronDown, ChevronUp } from "lucide-react";
import situations from "../data/situations.json";

function speak(text) {
  if ("speechSynthesis" in window) {
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.8;
    u.lang = "en-US";
    window.speechSynthesis.speak(u);
  }
}

export default function Situations() {
  const [openId, setOpenId] = useState(situations[0].id);

  return (
    <div className="space-y-6 page-enter relative">
      <div className="blob blob-amber" style={{ width: 320, height: 320, top: -40, right: -40, opacity: 0.18 }} />
      <div className="blob blob-emerald" style={{ width: 260, height: 260, top: 280, left: -40, opacity: 0.15 }} />
      <div className="relative">
        <h1 className="font-display text-4xl md:text-5xl font-normal mb-2"><em>Situations.</em></h1>
        <p className="text-gray-600 dark:text-gray-300 font-semibold">Ready-to-use English phrases for real-life places and scenarios.</p>
      </div>

      <div className="space-y-4">
        {situations.map((sit) => {
          const isOpen = openId === sit.id;
          return (
            <div key={sit.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <button
                onClick={() => setOpenId(isOpen ? null : sit.id)}
                className="w-full flex items-center justify-between p-6 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-cream-100 rounded-xl flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-gold-700" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-bold text-gray-800">{sit.title}</h3>
                    <p className="text-sm text-gray-400">{sit.phrases.length} phrases</p>
                  </div>
                </div>
                {isOpen ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
              </button>

              {isOpen && (
                <div className="px-6 pb-6 space-y-3">
                  {sit.phrases.map((p, i) => (
                    <div key={i} className="bg-gray-50 rounded-xl p-4 flex items-start gap-3">
                      <button
                        onClick={() => speak(p.english)}
                        className="p-2 bg-cream-100 rounded-full text-gold-700 hover:bg-cream-200 transition-all flex-shrink-0 mt-0.5"
                      >
                        <Volume2 className="w-4 h-4" />
                      </button>
                      <div className="flex-1">
                        <p className="font-medium text-gray-800">{p.english}</p>
                        <span className="text-xs text-gold-700 bg-paper-deep px-2 py-0.5 rounded-full mt-1 inline-block">
                          {p.use}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
